export type IcBackToTopVariants = "default" | "icon";
export type IcBackToTopPositions = "left" | "center" | "right";
